import * as React from 'react'
import type { Track } from 'types/track'
import { getTracksDuration } from '@disco/utils/tracks'
type Props = {
  tracks: Track[]
}

const ShortlistDuration = ({
  tracks,
}: Props): null | React.ReactElement<React.ComponentProps<'span'>, 'span'> => {
  const displayString = getTracksDuration(tracks)
  return displayString ? <span> | {displayString}’</span> : null
}

export default ShortlistDuration
